import { Reducer } from 'redux';
import { ConnectivityChipsState, ConnectivityChipsTypes } from './types';

export const INITIAL_STATE: ConnectivityChipsState = {
  list: [],
  totalCount: 0,
  current: null,
  error: false,
  loading: false,
};

const reducer: Reducer<ConnectivityChipsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // LIST CONNECTIVITY CHIPS
    case ConnectivityChipsTypes.LIST_CONNECTIVITY_CHIPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        list: INITIAL_STATE.list,
      };
    case ConnectivityChipsTypes.LIST_CONNECTIVITY_CHIPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        list: action.payload.connectivityChips,
        totalCount: action.payload.totalCount,
      };
    case ConnectivityChipsTypes.LIST_CONNECTIVITY_CHIPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        list: INITIAL_STATE.list,
      };

    // GET CONNECTIVITY CHIP
    case ConnectivityChipsTypes.GET_CONNECTIVITY_CHIP_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        current: INITIAL_STATE.current,
      };
    case ConnectivityChipsTypes.GET_CONNECTIVITY_CHIP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        current: action.payload.connectivityChip,
      };
    case ConnectivityChipsTypes.GET_CONNECTIVITY_CHIP_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        current: INITIAL_STATE.current,
      };

    default:
      return state;
  }
};

export default reducer;
